import * as Yup from 'yup'

const validationSchema = Yup.object({
  title: Yup.string().required('Title is required'),
  category: Yup.string().required('Category is required'),
  userLimit: Yup.number().required('User Limit is required'),
  userType: Yup.string().required('User Type is required'),
  discountType: Yup.string().required('Discount Type is required'),
  discountAmount: Yup.number().required('Discount Amount is required'),
  startDate: Yup.date().required('Start Date is required'),
  endDate: Yup.date().required('End date is required'),
  code: Yup.string().required('Code is required'),
})

export default {
  validationSchema,
}
